export const popoverContent = () => (
    <div>
        Si pas de mission laisser vide et <span className="span-bold">Période de la mission</span> = <span className="span-bold">toutes périodes</span>
    </div>
);